import { gql } from 'graphql-tag';

export const GET_CATALOG_RESOURCES_COUNT = gql`
  query GetCatalogResourcesCount(
    $preview: Boolean!
    $skipLessons: Int
    $skipCourses: Int
    $skipLearningPaths: Int
    $skipCertifications: Int
    $skipCollections: Int
    $skipInstructorLedTraining: Int
    $searchValue: String
  ) {
    learningPathCollection(
      preview: $preview
      limit: 25
      skip: $skipLearningPaths
      where: {
        hideFromCatalog_exists: false
        OR: [{ title_contains: $searchValue }, { learningPathSummary_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        deployment
        title
        learningPathSummary {
          json
        }
        product
        learningLevel
        productRole
        coursesCollection(where: { sys: { id_exists: true } }, limit: 20) {
          items {
            lessonsCollection(where: { sys: { id_exists: true } }, limit: 20) {
              items {
                duration
              }
            }
          }
        }
      }
    }
    smCourseCollection(
      preview: $preview
      limit: 25
      skip: $skipCourses
      where: {
        hideFromCatalog_exists: false
        OR: [{ title_contains: $searchValue }, { overview_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        title
        overview {
          json
        }
        deployment
        product
        learningLevel
        productRole
        lessonsCollection(where: { sys: { id_exists: true } }, limit: 20) {
          items {
            duration
          }
        }
      }
    }
    smLessonCollection(
      preview: $preview
      limit: 25
      skip: $skipLessons
      where: {
        hideFromCatalog_exists: false
        OR: [{ title_contains: $searchValue }, { description_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        title
        description
        deployment
        products
        productRole
        duration
      }
    }
    certificationCollection(
      preview: $preview
      limit: 25
      skip: $skipCertifications
      where: {
        hideFromCatalog_exists: false
        OR: [{ certificationTitleExternal_contains: $searchValue }, { certificationDescription_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        product
        certificationTitleExternal
        certificationDescription
      }
    }
    roleCollection(
      preview: $preview
      limit: 25
      skip: $skipCollections
      where: {
        hideFromCatalog_exists: false
        OR: [{ titleExternal_contains: $searchValue }, { description_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        product
        titleExternal
        description
      }
    }
    topicCollection(
      preview: $preview
      limit: 25
      skip: $skipCollections
      where: {
        hideFromCatalog_exists: false
        OR: [{ topicTitleExternal_contains: $searchValue }, { topicDescription_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        product
        topicTitleExternal
        topicDescription
      }
    }
    certificationPrepCollection(
      preview: $preview
      limit: 25
      skip: $skipCollections
      where: {
        hideFromCatalog_exists: false
        OR: [{ certificationPrepTitleExternal_contains: $searchValue }, { description_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        certificationPrepTitleExternal
        description
        relatedCertification {
          product
        }
      }
    }
    instructorLedTrainingCollection(
      preview: $preview
      limit: 25
      skip: $skipInstructorLedTraining
      where: {
        hideFromCatalog_exists: false
        OR: [{ courseTitleExternal_contains: $searchValue }, { courseSummary_contains: $searchValue }]
      }
    ) {
      items {
        __typename
        title: courseTitleExternal
        courseSummary
        slug: intellumUrl
        deployment
        product
        productRole
        learningLevel
        duration
      }
    }
  }
`;
